import { createContext, useContext } from 'react';
export const defaultValue = {
  activePage: null,
  isPageLoading: false,
  setIsPageLoading: () => {}
};
export const TemplatesContext = /*#__PURE__*/createContext(defaultValue);
export const useTemplatesContext = () => useContext(TemplatesContext);
//# sourceMappingURL=TemplatesContext.js.map